<template>
  <div>
    <v-card-title>
      <v-text-field
              append-icon="search"
              label="Nom, prénom, groupe politique, circonscription..."
              single-line
              hide-details
              v-model="search"
      ></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="senateurs" :search="search"
                  :rows-per-page-items="rowsPerPage"
                  :rows-per-page-text="'Éléments par page'"
                  :pagination.sync="pagination"
                  :no-data-text="search?'Aucune correspondance':'Aucun Sénateur chargé. Chargement en cours...'"
                  :customFilter="customFilter"
                  ref="tableSens"
                  id="tableSens"
                  :key="rowsPerPage.value">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left" v-if="showDesktop">
          <lazy-component>
          <img :src="`https://www.senat.fr/senimg/${props.item.baseNotice}.jpg`"
                                      :alt="`Photo de ${props.item.qualite} ${props.item.nomUsuel} ${props.item.prenomUsuel}`"
                                      class="photoSen">
          </lazy-component>
        </td>
        <td class="text-xs-left">{{props.item.qualite}} {{props.item.nomUsuel}} {{props.item.prenomUsuel}}</td>
        <td class="text-xs-left" v-if="showDesktop">{{props.item.groupePolitiqueCourant}}</td>
        <td class="text-xs-left" v-if="showDesktop">{{props.item.nomCirco}} ({{props.item.codeDpt}})</td>
        <td style="width: 30px;"><v-btn fab dark small class="red darken-4" :to="'/senateur/' + props.item.matricule"><v-icon>zoom_in</v-icon></v-btn></td>
      </template>
      <template slot="pageText" slot-scope="{pageStart, pageStop, itemsLength}">
        {{pageStart}}-{{pageStop}} de {{itemsLength}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import * as types from "../store/types";

  export default {
    data() {
      return {
        rowsPerPage: [{text: "Tous", value: -1}],
        headersSmall: [{
          text: "Qualité, nom et prénom",
          align: "left",
          sortable: true,
          value: "nomTechnique"
        },{
          align: "left",
          sortable: false
        }],
        headersBig: [{
          align: "left",
          sortable: false
        },{
          text: "Qualité, nom et prénom",
          align: "left",
          sortable: true,
          value: "nomTechnique"
        },{
          text: "Groupe politique",
          align: "left",
          sortable: true,
          value: "groupePolitiqueCourant"
        },{
          text: "Circonscription",
          align: "left",
          sortable: true,
          value: "nomCirco"
        },{
          align: "left",
          sortable: false
        }],
        pagination: {
          sortBy: "nomTechnique"
        },
        search: undefined
      };
    },
    props: {
      matricule: {
        type: String, required: false
      }
    },
    computed: {
      ...mapGetters({
        senateurs: types.ACCEDE_SENS_DISPOS
      }),
      showDesktop() {
        return this.$mq.resize && this.$mq.above(700);
      },
      headers() {
        if(this.showDesktop) {
          return this.headersBig;
        } else {
          return this.headersSmall;
        }
      }
    },
    methods: {
      customFilter(sens, recherche) {
        if(!recherche) {
          return sens;
        }
        recherche = recherche.toLocaleLowerCase();
        return sens.filter(s => {
          return s.nomUsuel.toLocaleLowerCase().includes(recherche)
            || s.prenomUsuel.toLocaleLowerCase().includes(recherche)
            || s.nomCirco.toLocaleLowerCase().includes(recherche)
            || s.codeDpt.includes(recherche)
            || `${s.qualite} ${s.nomUsuel} ${s.prenomUsuel}`.toLocaleLowerCase().includes(recherche)
            || `${s.qualite} ${s.prenomUsuel} ${s.nomUsuel}`.toLocaleLowerCase().includes(recherche);
        });
      },
      ajusteTailleEcran() {
        let nbRows = Math.max(2, Math.floor(((window.innerHeight - 260) / 60) - 1));
        this.setRowsPerPage(nbRows);
      },
      setRowsPerPage(nbRows) {
        this.pagination.rowsPerPage = nbRows;
        this.rowsPerPage = [{text: nbRows, value: nbRows},{text: "Tous", value: -1}];
      }
    },
    created() {
      let nbRows = Math.max(2, Math.floor(((window.innerHeight - 260) / 60) - 1));
      this.setRowsPerPage(nbRows);
      if(this.matricule) {
        this.$router.replace("/senateur/" + this.matricule);
      }
    }

  };
</script>

<style scoped>
  .photoSen {
    width: 35px;
  }

  @media (max-width: 700px) {
    #tableSens {
      width: 80vw;
      overflow: visible;
    }
    #tableSens table, #tableSens table tr {
      width: 100%;
    }

  }
</style>



// WEBPACK FOOTER //
// Accueil.vue?e8c3c11a